import { React, i18n, inject, pr, ui } from "aaa";
import { MessageScreen } from "../common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { ActivateCardStore } from "./ActivateCardStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: ActivateCardStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore", "authStore")
export class ActivateCardSuccess extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    render() {
        const card = this.props.store.cardStore.card;
        const product = card ? card.productI18N : "-";
        const cardNumber = card ? card.number : "-";

        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                messageComponent={
                    <div>
                        <i18n.FormattedHTMLMessage id="activateCard.success" values={{ product, number: cardNumber }} />
                    </div>}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess("geoControl")}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/activateCard/ActivateCardSuccess.tsx